// Estilo do modal de Fornecedor.
//
// Só o que a casca (`_casca.ts`) NÃO tem. Tudo o que já existe lá — overlay,
// conteúdo, cabeçalho, inputs, lista lateral, MiniTable, AlertMessage,
// InfoBadge — é importado de lá pelo componente, para o visual não divergir
// sozinho de um modal para o outro.
//
// Tokens: só `var(--u)`, `var(--fs-*)` e `var(--sp-*)`.
import styled from "styled-components";

/**
 * O texto que conta uma dívida na própria tela: campo que não tem onde ser
 * gravado, número que depende de módulo inexistente, rota que falta. Não é
 * erro nem sucesso — é a explicação que impede o usuário de achar que digitou
 * errado.
 */
export const NotaDeCampo = styled.p`
  grid-column: 1 / -1;
  margin: var(--sp-8) 0 0 0;
  font-size: var(--fs-xs);
  line-height: 1.5;
  color: #5b6b7b;

  code {
    font-family: ui-monospace, "SF Mono", Menlo, monospace;
    font-size: var(--fs-2xs);
    background: #eef2f6;
    padding: 0 var(--sp-4);
    border-radius: 4px;
  }
`;

/** Grade dos indicadores calculados (somente leitura). */
export const GradeDeCalculados = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 240), 1fr));
  gap: var(--sp-12);
`;

export const CampoCalculado = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-12);
  border: 1px dashed ${(props) => props.theme.colors.borderColor || "#e0e0e0"};
  border-radius: 8px;
  background: #f7f9fb;
`;

export const TituloDoCalculado = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-8);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
`;

/**
 * O travessão. É o valor de propósito: mostrar "0%" de entrega no prazo para um
 * fornecedor que nunca teve entrega medida seria inventar o placar dele.
 */
export const ValorCalculado = styled.div`
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: #8a97a4;
  line-height: 1;
`;

export const ExplicacaoCurta = styled.div`
  font-size: var(--fs-2xs);
  line-height: 1.5;
  color: #6b7885;
`;

/** Fila de checkboxes de dia da semana (janela de atendimento, dias de entrega). */
export const LinhaDeDias = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-8);
`;

export const BotaoDeDia = styled.button<{ ativo?: boolean }>`
  padding: var(--sp-6) var(--sp-12);
  border-radius: 999px;
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: ${(props) => (props.ativo ? 600 : 400)};
  border: 1px solid
    ${(props) =>
      props.ativo
        ? props.theme.colors.selection
        : props.theme.colors.borderColor || "#e0e0e0"};
  background: ${(props) =>
    props.ativo ? props.theme.colors.selection + "22" : "transparent"};
  color: ${(props) => props.theme.colors.text};
`;

/** O formulário de linha que fica embaixo da MiniTable de preços acordados. */
export const FormularioDeLinha = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 180), 1fr));
  gap: var(--sp-12);
  padding: var(--sp-16);
  margin-top: var(--sp-16);
  border: 1px solid ${(props) => props.theme.colors.borderColor || "#e0e0e0"};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.background + "40"};
`;

export const AcoesDaLinha = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-12);
`;

/** O que a MiniTable mostra quando o fornecedor ainda não tem preço nenhum. */
export const ListaVazia = styled.div`
  padding: var(--sp-24);
  text-align: center;
  font-size: var(--fs-sm);
  color: #6b7885;
  border: 1px dashed ${(props) => props.theme.colors.borderColor || "#e0e0e0"};
  border-radius: 8px;
`;
